import {
  MENSAGENS_ERRO_NORMALIZACAO,
  type NormalizarLogoRequest,
  type NormalizarLogoResponse,
} from './normalizacao'

const TIMEOUT_NORMALIZACAO_EM_MS = 60_000

export async function normalizarLogoDoParceiro(arquivo: File): Promise<File> {
  if (typeof Worker === 'undefined' || typeof globalThis.crypto?.randomUUID !== 'function') {
    throw new Error(MENSAGENS_ERRO_NORMALIZACAO['navegador-incompativel'])
  }

  const id = globalThis.crypto.randomUUID()
  let worker: Worker
  try {
    worker = new Worker(new URL('../../workers/normalizar-logo.worker.ts', import.meta.url), {
      type: 'module',
    })
  } catch {
    throw new Error(MENSAGENS_ERRO_NORMALIZACAO['navegador-incompativel'])
  }

  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      finalizar()
      reject(new Error('A otimização da logo demorou demais. Tente outra imagem.'))
    }, TIMEOUT_NORMALIZACAO_EM_MS)

    function finalizar() {
      window.clearTimeout(timeout)
      worker.terminate()
    }

    worker.onerror = () => {
      finalizar()
      reject(new Error(MENSAGENS_ERRO_NORMALIZACAO['falha-processamento']))
    }

    worker.onmessage = ({ data }: MessageEvent<NormalizarLogoResponse>) => {
      if (!data || data.id !== id) return
      finalizar()

      if (!data.success) {
        reject(new Error(MENSAGENS_ERRO_NORMALIZACAO[data.errorCode]))
        return
      }

      if (!(data.blob instanceof Blob) || data.blob.type !== 'image/webp' || !data.blob.size) {
        reject(new Error(MENSAGENS_ERRO_NORMALIZACAO['falha-processamento']))
        return
      }

      const nomeBase = arquivo.name.replace(/\.[^.]+$/, '') || 'logo'
      resolve(new File([data.blob], `${nomeBase}.webp`, { type: 'image/webp' }))
    }

    const request: NormalizarLogoRequest = { id, arquivo }
    try {
      worker.postMessage(request)
    } catch {
      finalizar()
      reject(new Error(MENSAGENS_ERRO_NORMALIZACAO['falha-processamento']))
    }
  })
}
